// extracted by mini-css-extract-plugin
module.exports = {"CBButton":"callback-form-button_CBButton__RHoer"};